import React from "react";
import { NavLink } from "react-router-dom";

function Header()
{
    return (
        <React.Fragment>
            <header className="d-flex align-items-center pb-3 border-bottom">
                <a href="/" className="d-flex align-items-center text-dark text-decoration-none">
                    <h1 className="fs-3"><b>Lucas RODRIGUEZ</b></h1>
                </a>
            </header>
            <div className="navigation_bar">
                <NavLink activeClassName='active_link' exact to={{ pathname: "/", state: { prevPath: window.location.pathname } }}>About</NavLink>
                <NavLink activeClassName='active_link' to={{ pathname: "/projects", state: { prevPath: window.location.pathname } }}>Projects</NavLink>
                <NavLink activeClassName='active_link' to={{ pathname: "/articles", state: { prevPath: window.location.pathname } }}>Articles</NavLink>
                {/*<NavLink activeClassName='active_link' to={{ pathname: "/papers", state: { prevPath: window.location.pathname } }} >Readings</NavLink >*/}
                <NavLink activeClassName='active_link' to={{ pathname: "/contact", state: { prevPath: window.location.pathname } }} >Contact</NavLink >
            </div >
        </React.Fragment >);
}
export default Header;